module.exports = __webpack_public_path__ + "images/3edd2bda7b5b99a4f1d74b830f0ea6a4-SensorGroup.png";